__turbopack_context__.v({
  "select-content": "RB7K5G_select-content",
  "select-content__item": "RB7K5G_select-content__item",
  "select-trigger": "RB7K5G_select-trigger",
  "select-trigger__icon": "RB7K5G_select-trigger__icon",
  "select-trigger__value": "RB7K5G_select-trigger__value",
});
